import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The 3 types of scalability",
  "description": "",
  "published": "2020-05-01T00:00:00.000Z",
  "redirect_from": ["/blog/the-3-types-of-scalability/swizec/9402"],
  "categories": "Technical",
  "hero": "./img/aCAfBFa.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You ask a room full of engineers `}<em parentName="p">{`"So how's this gonna scale?"`}</em>{` and step out for a glass of water. When you're back, all hell has broken loose.`}</p>
    <p>{`Bob is choking Harry. Lucy screams obscenities at John. Jane is furiously scribbling binary trees on the whiteboard, Stuart rocks crying in the corner, and Kevin the office plant is on fire.`}</p>
    <p>{`What the heck happened?`}</p>
    <p><img parentName="p" {...{
        "src": "/30fba4fa09aeb78d6b7a4d42921bb946/media-BfiL8ZJWqfw7C-giphy-downsized-medium.gif",
        "alt": "community_troy_pizza giphy"
      }}></img></p>
    <p>{`You committed one of 3 classic blunders:`}</p>
    <ol>
      <li parentName="ol">{`Never get involved in a land war in Asia`}</li>
      <li parentName="ol">{`Never challenge a Sicilian in a battle of wits`}</li>
      <li parentName="ol">{`Never mention scalability in a room full of engineers`}</li>
    </ol>
    <h2 {...{
      "id": "scalability-means-different-things-to-different-people"
    }}>{`Scalability means different things to different people`}</h2>
    <p>{`You see my friend, when you say "scalable", `}<em parentName="p">{`you`}</em>{` know exactly what you mean. And everyone around you hears something else.`}</p>
    <p>{`A piece of code or architecture can be scalable in many ways.`}</p>
    <p>{`The 3 biggest dimensions are:`}</p>
    <ol>
      <li parentName="ol">{`Vertical scalability`}</li>
      <li parentName="ol">{`Horizontal scalability`}</li>
      <li parentName="ol">{`Team scalability`}</li>
    </ol>
    <p>{`They're independent and the cause of many a heated debate.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/ec713e34a04dac77a1ff305e6c6f9a5e/38116/aCAfBFa.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.98654708520179%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'244\\'%20viewBox=\\'0%200%20400%20244\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M336%2011c-9%203-83%2039-96%2047l-9%205-8-1c-8-1-49%201-55%203-2%200-2%200-2-6%202-14%202-24%201-18l-2%2014v10h-5a917%20917%200%2001-116-1l-20%202c-1-2-4%200-6%204-2%203-2%206%200%203a3846%203846%200%2000-1%2076l-1%2072c-1%201-1%202%202%201l11-1a9078%209078%200%2001191%201c-5%201-8%203-5%203%204%200%2011-3%2011-4l3-4-3%201c-2%200-2%201%201-16l5-43v-15h31a1092%201092%200%2000-1-2h-30v-15a530%20530%200%20002-56l1-7a1410%201410%200%2001101-54M188%2065c-22%202-22%201-22%206l-1%2013c0%209%200%209%202%209%204%201%204%204%200%204-4%201-5%205-1%207l2%202h1c1-2%205-3%205-1l-7%203-2%202-1%202-2%201a292%20292%200%20011-12v-4l-3%202-3%202%202-2c1-1%201-1-1-2s-2-1%201-2c4%200%204%200%206-18V66h-3a991%20991%200%2001-120-1l-14%203h-6v4c1%203%201%203-1%202-1-1-1%201-1%2043v72c-1%2028-1%2032%202%2028h2c2%200%202%200%201-1s-1-1%202-2c3-2%204-2%204-1h3l1-2c-2%200-2%200%200-1%203-2%204-2%204-1v1c1%201-2%203-7%205l-8%205%2010-1h31c21%200%2022%200%2024-2h1c-1%202%201%202%2063%202a617%20617%200%200070-2%20316%20316%200%20007-73%20713%20713%200%2000-76%205%20786%20786%200%2001-55%2030%201222%201222%200%2001-59%2030v-1l4-3c5-3%206-4%206-2h2c2-1%202-1%201-2s1-2%205-4c6-3%207-4%207-2l3-1c2%200%203-1%203-2l-3%201-3%201c-1-1%2018-10%2020-9v-1h1c2%200%202%200%201-1-2-1%204-4%207-3v-1c-2-1%204-4%207-3v-2h2c0-1%2010-7%2024-14l24-13c1-2%2018-3%2049-4l31-1%201-36a284%20284%200%20012-42h-46\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/ec713e34a04dac77a1ff305e6c6f9a5e/ca0a1/aCAfBFa.webp 223w", "/static/ec713e34a04dac77a1ff305e6c6f9a5e/75680/aCAfBFa.webp 445w", "/static/ec713e34a04dac77a1ff305e6c6f9a5e/8d1ba/aCAfBFa.webp 890w", "/static/ec713e34a04dac77a1ff305e6c6f9a5e/3838e/aCAfBFa.webp 1335w", "/static/ec713e34a04dac77a1ff305e6c6f9a5e/e11e5/aCAfBFa.webp 1780w", "/static/ec713e34a04dac77a1ff305e6c6f9a5e/d37d3/aCAfBFa.webp 2086w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/ec713e34a04dac77a1ff305e6c6f9a5e/e92b6/aCAfBFa.png 223w", "/static/ec713e34a04dac77a1ff305e6c6f9a5e/e66bf/aCAfBFa.png 445w", "/static/ec713e34a04dac77a1ff305e6c6f9a5e/4ef49/aCAfBFa.png 890w", "/static/ec713e34a04dac77a1ff305e6c6f9a5e/4e814/aCAfBFa.png 1335w", "/static/ec713e34a04dac77a1ff305e6c6f9a5e/701e9/aCAfBFa.png 1780w", "/static/ec713e34a04dac77a1ff305e6c6f9a5e/38116/aCAfBFa.png 2086w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/ec713e34a04dac77a1ff305e6c6f9a5e/4ef49/aCAfBFa.png",
              "alt": "aCAfBFa",
              "title": "aCAfBFa",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Let me explain:`}</p>
    <p><strong parentName="p">{`1. vertical scalability`}</strong></p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Scalability#Vertical_or_Scale_Up"
      }}>{`Vertical scalability`}</a>{` is how much you can get out of a single machine. Primary considerations here are algorithmic complexity, programming language choice, execution environment, and machine beefiness.`}</p>
    <p>{`When you buy a new iPhone coz the old one got slow, that's vertical scalability.`}</p>
    <p>{`When you bicker about JavaScript "not scaling", that's vertical scalability.`}</p>
    <p>{`When you chat about Quicksort, Bubble Sort, and Hash Tables, that's vertical scalability.`}</p>
    <p><em parentName="p">{`How much work can we get out of the machine?`}</em></p>
    <p><strong parentName="p">{`2. horizontal scalability`}</strong></p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Scalability#Horizontal_or_Scale_Out"
      }}>{`Horizontal scalability`}</a>{` is how much you can get out of multiple machines. Primary considerations here are developer experience, managing servers, coordinating tasks, communication between nodes, and cost.`}</p>
    <p>{`When you split large payloads into small tasks, that's horizontal scalability.`}</p>
    <p>{`When you bicker about AWS Lambda vs. Docker VMs, that's horizontal scalability.`}</p>
    <p>{`When you think about coordinating 5 servers, 10 load balancers, 3 queues, and 8 kuberneteses, that's horizontal scalability.`}</p>
    <p><em parentName="p">{`How much work can we get out of many machines working together?`}</em></p>
    <p><strong parentName="p">{`3. team scalability`}</strong></p>
    <p>{`Team scalability is how much you can get out of multiple engineers. Primary concerns here are developer experience, communication, avoiding common mistakes, pull requests, tools over processes, and common guidelines.`}</p>
    <p>{`When you add automatic deploys to your workflow, that's team scalability.`}</p>
    <p>{`When you start using TypeScript to lower mental overhead, that's team scalability.`}</p>
    <p>{`When you build a library everyone can use, that's team scalability.`}</p>
    <p>{`When you split a monolith into microservices, that's team scalability. No really 😉`}</p>
    <p><em parentName="p">{`How can we get all these engineers to work together without `}<del parentName="em">{`stepping on each other's toes`}</del>{` killing each other?`}</em></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1255940255502356480"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "78.47533632286996%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'313\\'%20viewBox=\\'0%200%20400%20313\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2017c-5%202-7%206-7%2012%200%209%206%2015%2015%2015%206%200%2012-5%206-6-4%200-2-5%202-5%207-1%206-10-2-15-4-3-9-4-14-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/decbb9d5875f5bafb99696545ae1d975/ca0a1/techletter.app-screenshot-1588351340303.webp 223w", "/static/decbb9d5875f5bafb99696545ae1d975/75680/techletter.app-screenshot-1588351340303.webp 445w", "/static/decbb9d5875f5bafb99696545ae1d975/0ba47/techletter.app-screenshot-1588351340303.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/decbb9d5875f5bafb99696545ae1d975/e92b6/techletter.app-screenshot-1588351340303.png 223w", "/static/decbb9d5875f5bafb99696545ae1d975/e66bf/techletter.app-screenshot-1588351340303.png 445w", "/static/decbb9d5875f5bafb99696545ae1d975/6af66/techletter.app-screenshot-1588351340303.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/decbb9d5875f5bafb99696545ae1d975/6af66/techletter.app-screenshot-1588351340303.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`So my friend, which of these do `}<em parentName="p">{`you`}</em>{` spend most effort on? Hit reply.`}</p>
    <p>{`Happy Friday ❤️`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      